import { Component, ElementRef, NgZone, OnInit, TemplateRef, ViewChild} from "@angular/core";
import { FormGroup,  FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { ToastrService } from "ngx-toastr";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { environment } from "src/environments/environment";
import * as CONSTANT from '../../services/constants';
import { ImageUrls } from "src/app/services/s3buket";
import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from "@angular/common/http"

@Component({
  selector: "app-projects",
  templateUrl: "./projects.component.html",
  styleUrls: ["./projects.component.css"]
})
export class ProjectsComponent implements OnInit {
  modalRef?: BsModalRef;
  form: FormGroup;
  showError = false;
  showErrorToAdd = false;
  showTeamMemberError = false;
  showLinkSameError = false;
  // uni&spec
  allSpec:any=[];
  allUni:any=[];
  // datepicker
  minDate = new Date();
	maxDate = new Date();
	today: Date | undefined;
  // team member
  addTeam:FormGroup;
  title="Add";
  memberEditingPosition=-1;
  // awards
  awardList:any=[]; 
  fileUpload;
  globalUrl = ImageUrls.BaseUrl + ImageUrls.directories.users
  thumbnailImage:any=[];
  constructor(private modalService: BsModalService,private formBuilder: FormBuilder,public route: ActivatedRoute, private router: Router,private api: AdminService,private toastrService: ToastrService,private http: HttpClient, private handler: HttpBackend) {
    this.form = this.formBuilder.group({
      associatedWith: [""],
      projectTitle: ["", Validators.compose([Validators.required,Validators.maxLength(50)])],
      location: [""],
      fromDate: [""],
      toDate: [""],
      isCurrentlyOngoing: [""],
      description: ["", Validators.compose([ Validators.minLength(3),Validators.maxLength(250)])],
      projectMembers:[""],
      projectLinksTypeOf:["", Validators.compose([Validators.pattern(CONSTANT.URL_REGEX)])],
      projectLinks:[""],
      projectMedia:[""],
    });
    this.addTeam = this.formBuilder.group({
      name:["", Validators.compose([Validators.required])],
      email:["", Validators.compose([Validators.required,Validators.pattern(CONSTANT.EMAIL_REGEX)])],
    })
   }

  ngOnInit(): void { 
    this.getDetail()
  }
  
  // date picker only accpedct number
  onKeyDown(event: KeyboardEvent) {
    const key = event.key;
    if (!/^\d+$/.test(key)) {
      event.preventDefault();
    }
  }
  // getUniSpec
  getDetail(){
    this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getProjects)
    .subscribe(async (res) => {
      if(res.data != ""){
        this.router.navigate(["/projects/add"]);
      } else{
        this.router.navigate(["/projects"]);
      }
      
    })
  } 
  
  openModal(template: TemplateRef<any>) {
    this.title="Add";
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal centerAlign" })
    );
  }

  closeModal(){
   this.modalService.hide();
   this.addTeam.reset();
   this.memberEditingPosition = -1;
  }
  // add team member
  onAddTeam(){
    this.title ="Add"
    if(this.addTeam.valid){
      let members = this.form.value.projectMembers;

      if (this.memberEditingPosition == -1) {
        if (members == "") {
          members = [];
        }
        members.push({
          name: this.addTeam.value.name,
          email: this.addTeam.value.email
        });
      } else {
        members[this.memberEditingPosition] = {
          name: this.addTeam.value.name,
          email: this.addTeam.value.email
        }
        this.memberEditingPosition = -1;
      }
    
      this.form.patchValue({
        projectMembers: members
      }) 
      
      this.modalRef?.hide()
      this.addTeam.reset();
    } else{
      this.showTeamMemberError=true;
      setTimeout(() => {
        this.showTeamMemberError=false
      }, 3000);
    }
  }
  editMember(i,template: TemplateRef<any>){
    this.title="Edit";
    this.memberEditingPosition=i
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "modal-lg addModal centerAlign" })
    );
    setTimeout(() => {
      this.addTeam.patchValue(this.form.value.projectMembers[i])
    }, 200);
  }
  deleteMember(i){
    let members = this.form.value.projectMembers;
    members.splice(i,1)
    this.form.patchValue({
      projectMembers: members
    })
  }
  //
  // add awards
  addHonors(input, name){
    if(this.form.controls.projectLinksTypeOf.valid){
      this.form.patchValue({
        projectLinksTypeOf:""
      })
    if(name !== null && name.trim() != ""){
      var t = "https://www."; 
      var w = "www"; 
      if(name.toString() != "" && !name.toString().startsWith(t)&& !name.toString().startsWith(w)){
        name = t +name 
      } else if(name.toString() != "" && name.toString().startsWith(w)){  
        name = "https://" +name
      } 
      
      let containsLink = this.awardList.some((object) => 
      object.hasOwnProperty('name') && object['name'] === name
    )
      if (!containsLink) {
        this.awardList.push({name, orderByIndex: this.awardList.length + 1});
         input.value = "";
      } else {
        this.showLinkSameError = true;
        setTimeout(() => {
          this.showLinkSameError = false;
        }, 2500);
          return
      }
      // this.awardList.push({name, orderByIndex: this.awardList.length + 1});
      // input.value = "";
    }
    let awardName : any = []
    this.awardList.map((awards) => {
      awardName.push(awards.name);
    })
    this.form.patchValue({
      projectLinks :awardName
    })
  } else{
    this.showError = true;
    setTimeout(() => {
      this.showError = false;
    }, 2500);
    return
  }
  }
  
  deleteHonors(name) {
    const index = this.awardList.indexOf(name);
    if( index >= 0) this.awardList.splice(index, 1);
  } 
  // image upload
  upload(event) { 
		const files = event.target.files; 
     this.fileUpload = files[0];
		this.uploadFileToS3();
	}
	
	uploadFileToS3() {
		const data = {
			"directory":ImageUrls.directories.users,
			"fileName": this.fileUpload.name,
			"contentType": this.fileUpload.type
		} 
		this.api.postData(apiUrl._upload, data)
			.subscribe(res => {
				this.http = new HttpClient(this.handler);
				this.http.put<any>(res.data.uploadURL, this.fileUpload).subscribe(response => {
         this.thumbnailImage.push({ name:this.fileUpload.name,fileName:res.data.fileName})
         this.form.patchValue({
          projectMedia:this.thumbnailImage
         })
				})
			})
	} 
  // 
  deleteImage(i){
    this.thumbnailImage.splice(i,1);
    this.form.patchValue({
      projectMedia:this.thumbnailImage
     })
  }
  // on submit
  onSubmit(){ 
    if(this.form.value.isCurrentlyOngoing == 1 || this.form.value.isCurrentlyOngoing == true){
      this.form.patchValue({
        isCurrentlyOngoing : 1
      })
    }
    if(this.form.value.isCurrentlyOngoing == 1 && this.form.value.fromDate == ""){
      this.showError= true;
      setTimeout(() => {
        this.showError= false;
      }, 3000);
      return
    }
    if(this.form.value.projectLinksTypeOf != ""){
      this.showErrorToAdd = true;
      setTimeout(() => {
        this.showErrorToAdd = false;        
      }, 3000);
      return
    }
    if(this.form.valid){
      delete this.form.value.projectLinksTypeOf;
      this.api.postData(apiUrl._addProjects, this.removeEmptyFiled(this.form))
      .subscribe(async (res) => {
        this.toastrService.success("", "Projects Added Successfully!");
        this.router.navigate(["/projects/add"]);
      })
    } else{
      this.showError= true;
      setTimeout(() => {
        this.showError= false;
      }, 3000);
    }
    
  }
  removeEmptyFiled(form){
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }

    return formValues
  }

  isDisabled(event:any){
    if(event.target.checked) {
      this.form.controls['toDate'].disable();
    } else {
      this.form.controls['toDate'].enable();
    }
  }
}
